import { ITagItemInput } from '@hts/shared/types';
import { memo } from 'react';
import { ICategoryListFilters } from '../../types';

interface ICategoryTagsProps {
  tags: ITagItemInput[];
  filters: ICategoryListFilters;
  toggleFilters: (filter: string, value: string) => void;
}

export const CategoryTags: React.FC<ICategoryTagsProps> = memo(
  ({ tags, filters, toggleFilters }) => {
    return (
      <div className="category-tags-holder">
        {tags.length > 0 && (
          <ul>
            {tags.map((tag, i) => (
              <li key={`${tag.id}-${i}`}>
                <a
                  href="/"
                  className={
                    filters['tags'].includes(tag.slug)
                      ? 'btn btn-outline-secondary active'
                      : 'btn btn-outline-secondary'
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    toggleFilters('tags', tag.slug);
                  }}
                >
                  {tag.name}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
);
